"use client";

import { cn } from "@/lib/utils";
import React, { useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { ROUTES } from "@/@core/constants/routes";
import { useTranslation } from "@/hooks/translationContext";

export default function LegalPagesLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { t } = useTranslation();
  const router = useRouter();
  const pathname = usePathname().slice(1);

  const termsWithOutSlash = ROUTES.LEGAL.TERMS.slice(1);
  const legalWarningWithOutSlash = ROUTES.LEGAL.WARNING.slice(1);

  const getTitle = () => {
    switch (true) {
      case pathname === termsWithOutSlash:
        return t("legal-terms-page-title");
      case pathname === legalWarningWithOutSlash:
        return t("legal-notice-page-title");
    }
  };

  const buttons = [
    {
      text: t("legal-terms-page-title"),
      href: ROUTES.LEGAL.TERMS,
      withOutSlash: termsWithOutSlash,
    },
    {
      text: t("legal-notice-page-title"),
      href: ROUTES.LEGAL.WARNING,
      withOutSlash: legalWarningWithOutSlash,
    },
  ];

  return (
    <div className="container">
      <header className="flex flex-wrap justify-between items-start gap-6 py-6">
        <h1 className="text-[32px] font-bold text-primary gap-2 md:gap-4">
          {getTitle()}
        </h1>

        <div className="flex flex-wrap w-full md:w-auto items-start content-start self-stretch rounded-3xl gap-4 p-4 md:gap-2 md:p-2 xl:rounded-7xl bg-gray">
          {buttons.map((button) => (
            <button
              role="button"
              key={button.href}
              className={cn(
                "py-2 px-4 text-base font-bold rounded-8xl duration-300",
                pathname === button.withOutSlash
                  ? "bg-white"
                  : "text-assistant",
              )}
              onClick={() => {
                router.push(button.href);
              }}
            >
              {button.text}
            </button>
          ))}
        </div>
      </header>

      <div className="absolute left-0 w-full h-[1px] bg-gray-secondary"></div>
      <p className="text-primary font-medium font-sans py-4">{children}</p>
    </div>
  );
}
